/* eslint-disable @typescript-eslint/no-explicit-any */
import { ENDPOINTS } from '@/util'
// import { pageData } from '@/unity-apps/mock-data/page-layout/page-layout-3'
import { useSuspenseQuery } from '@tanstack/react-query'
import { TableResponse } from './types-v4'
import { useGetFilterSelections } from '@/unity-apps/hooks/useGetFilterSelections'
// import { json } from '@/unity-apps/mock-data/table/table-response.json'

// const tableResposne = json as TableResponse

interface GetTableParams {
  appKey?: string
  contentId?: string
  projectId?: number
  filterSelections: Record<string, any>[]
}
const getTable = async ({ appKey, contentId, projectId, filterSelections }: GetTableParams) => {
  if (!appKey || !contentId || !projectId) {
    throw new Error('Missing required parameters')
  }
  // return Promise.resolve(tableResposne)
  const url = `${ENDPOINTS.CC}/content`
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-type': 'application/json' },
    body: JSON.stringify({
      app_id: appKey,
      content_id: contentId,
      // content_id: '/showcase/full/table/defs',
      project_id: projectId,
      // filters: {},
      filters: filterSelections,
    }),
  })
  const data = await response.json()
  if (response.ok) {
    // return data.uiSchema as PageData
    return data as TableResponse
  }
  throw new Error('Failed to fetch app page')
}

export function useGetTable(contentId: string, tileFilterSelections: Record<string, any>[]) {
  console.log('useGetTable - tileFilterSelections', tileFilterSelections)
  const { filterSelections, appKey, projectId } = useGetFilterSelections()
  // const pageId = `/${appKey}/pages/${page}${splat ? `/${splat}` : ''}`
  return useSuspenseQuery({
    queryKey: [contentId, appKey, projectId, [...filterSelections, ...tileFilterSelections]],
    queryFn: () =>
      getTable({ appKey, contentId, projectId, filterSelections: [...filterSelections, ...tileFilterSelections] }),
    // queryFn: async () => {
    //   const data = new Promise((res) => {
    //     setTimeout(() => res(pageData), 1000)
    //   })
    //   return (await data) as typeof pageData
    // },
  })
}
